import Dexie from 'dexie';

import { dbV2, ledgerDatabaseExists } from './dbV2';
import { type PersistedStatus } from './types';

/**
 * Every persisted chunk and backup status for one session, unfiltered. Never
 * creates the ledger database: hydrate reads its existence as audio to drain.
 */
export async function listSessionPersistedAudioStatuses(
  sessionId: string
): Promise<{ chunks: PersistedStatus[]; backups: PersistedStatus[] }> {
  if (!sessionId) return { chunks: [], backups: [] };
  if (!dbV2.isOpen() && !(await ledgerDatabaseExists())) {
    return { chunks: [], backups: [] };
  }
  const range: [[string, typeof Dexie.minKey], [string, typeof Dexie.maxKey]] = [
    [sessionId, Dexie.minKey],
    [sessionId, Dexie.maxKey],
  ];
  const [chunks, backups] = await Promise.all([
    dbV2.chunks
      .where('[sessionId+recordingId]')
      .between(...range)
      .toArray(),
    dbV2.backups
      .where(':id')
      .between(...range)
      .toArray(),
  ]);
  return {
    chunks: chunks.map((chunk) => chunk.status),
    backups: backups.map((backup) => backup.status),
  };
}
